import { render, staticRenderFns } from "./StepsWriterZhihu.vue?vue&type=template&id=47ec876a&scoped=true"
import script from "./StepsWriterZhihu.vue?vue&type=script&lang=js"
export * from "./StepsWriterZhihu.vue?vue&type=script&lang=js"
import style0 from "./StepsWriterZhihu.vue?vue&type=style&index=0&id=47ec876a&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47ec876a",
  null
  
)

export default component.exports